import { useMemo } from 'react';
import type { Collect } from '../types';

export function useCollectsByDate(collects: Collect[]): Record<string, Collect[]> {
  return useMemo(() => {
    const map: Record<string, Collect[]> = {};
    for (const collect of collects) {
      if (!map[collect.date]) map[collect.date] = [];
      map[collect.date].push(collect);
    }
    return map;
  }, [collects]);
}
